module.exports = __webpack_public_path__ + "static/img/video_report3d.b55688df.png";